import styled from 'styled-components'
import banner from '../../images/backdrops/banner_bgM.png'

export const PageStyle = styled.div`
  background: white;
  overflow-y: scroll;
  height: ${(props) => props.mobileHeight - 60}px;

  .header-banner {
    background-image: url(${banner});
    background-position: center top;
    background-size: cover;
    padding: 0;
    img {
      max-width: 100%;
    }
  }
  .agenda-grid {
    display: grid;
    grid-auto-rows: max-content;
    position: relative;
    grid-gap: 30px;
  }
  .mobile-hide {
    display: none !important;
  }
  .mobile-show {
    display: block !important;
  }
`